export const categories = [
  {
    id: "fashion",
    name: "时尚大片",
    description: "霓虹、丝绒与高定造型交织，捕捉女性在时尚语境下的鲜明态度与高级质感。",
    icon: "ri-vip-diamond-line",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20high%20fashion%20editorial%20portrait%20of%20a%20woman%20in%20flowing%20silk%20gown%2C%20warm%20amber%20studio%20lighting%2C%20soft%20neutral%20beige%20backdrop%2C%20luxury%20magazine%20aesthetic%2C%20high%20detail%20photography&width=900&height=1200&seq=cat-fashion-01&orientation=portrait",
  },
  {
    id: "art",
    name: "艺术摄影",
    description: "以身体、光影与几何为语言，探索女性形态与抽象视觉之间的诗意边界。",
    icon: "ri-camera-lens-line",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20fine%20art%20photograph%20of%20a%20woman%20silhouette%20against%20soft%20warm%20light%20and%20shadow%2C%20minimal%20cream%20background%2C%20poetic%20abstract%20composition%2C%20gallery%20quality%2C%20high%20detail&width=900&height=1200&seq=cat-art-01&orientation=portrait",
  },
  {
    id: "life",
    name: "生活写真",
    description: "晨光、书店与海边日常，记录女性真实而松弛的生活瞬间，温暖又有呼吸感。",
    icon: "ri-sun-line",
    cover:
      "https://readdy.ai/api/search-image?query=candid%20lifestyle%20portrait%20of%20a%20woman%20in%20soft%20morning%20light%20near%20a%20window%2C%20warm%20cream%20tones%2C%20cozy%20natural%20interior%2C%20gentle%20authentic%20mood%2C%20high%20detail%20photography&width=900&height=1200&seq=cat-life-01&orientation=portrait",
  },
  {
    id: "creative",
    name: "创意特辑",
    description: "超现实、色彩实验与镜像迷宫，用大胆想象为女性视觉艺术打开另一种可能。",
    icon: "ri-magic-line",
    cover:
      "https://readdy.ai/api/search-image?query=surreal%20creative%20conceptual%20photograph%20of%20a%20woman%20with%20vivid%20colorful%20set%20design%2C%20dreamlike%20playful%20composition%2C%20warm%20orange%20and%20gold%20palette%2C%20high%20detail%20art%20photography&width=900&height=1200&seq=cat-creative-01&orientation=portrait",
  },
];